export const LIVE_NEWS = "LIVE_NEWS";
export const EQUITY_HOLDING_LIVE_NEWS = "EQUITY_HOLDING_LIVE_NEWS";
export const LIVE_NEWS_ERROR = "LIVE_NEWS_ERROR";
export const LIVE_NEWS_HIDE_ERROR = "LIVE_NEWS_HIDE_ERROR";
export const LIVE_NEWS_START_LOADER = "LIVE_NEWS_START_LOADER";
export const LIVE_NEWS_STOP_LOADER = "LIVE_NEWS_STOP_LOADER";
export const QOUTE_STREAM_NEWS = "QOUTE_STREAM_NEWS";
export const LIVE_NEWS_STREAM = "LIVE_NEWS_STREAM";
export const RESET_STREAM_COUNT = "RESET_STREAM_COUNT";
